import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store.js'
import axios from 'axios'
import { checkFeatures } from '@/utils/featureUtils'

// Containers
const TheContainerFluid = () => import('@/containers/TheContainerFluid')
const TheContainer = () => import('@/containers/TheContainer')
const EmptyContainer = () => import('@/containers/EmptyContainer')
// Views
const Home = () => import('@/views/home/Home')
const WaitingConfiguration = () => import('@/views/home/WaitingConfiguration')
const OrganizationPendingPlan = () => import('@/views/home/OrganizationPendingPlan')

const notFound = () => import('@/views/pages/Page404.vue')
const Download = () => import('@/views/pages/Download.vue')
const PaymentConfirmation3ds = () => import('@/views/pages/PaymentConfirmation3ds.vue')

const TheMainSidebar = () => import('@/containers/TheMainSidebar')
const CountDown = () => import('@/views/pages/CountDown')

const DocumentationWrapper = () => import('@/views/api/pages/DocumentationWrapper.vue')

const setOrganization = () => import('@/views/pages/SetOrganization.vue')

// Views - Auth
import { authRoutes } from '@/views/auth'

// Views - Pages Audience
import { audienceRoutes } from '@/views/audience'

// Views - Pages Audience
import { campaignRoutes } from '@/views/campaign'

// Views - Pages Setings
import { userRoutes } from '@/views/user'

// Views - Pages Setings
import { sendersRoutes } from '@/views/senders'

// Views - Pages Securituy
import { securityRoutes } from '@/views/security'

// Views - Pages template EMAIL/SMS
import { templateRoutes } from '@/views/template'

// Views - Organizations
import { organizationRoutes } from '@/views/organization'

// Views - Plan ans Subscriptions
import { plansSubscriptionsRoutes } from '@/views/plansSubscriptions'

// Views - Requests area
import { requestRoutes } from '@/views/request'

import { transactionRoutes } from '@/views/transaction'
import { transactionLogsRoutes } from '@/views/transaction'

// Views - backOffice area
import { backOfficeRoutes } from '@/views/backOffice'

// Views - balance area
import { balanceRoutes } from '@/views/balance'

// Views - Faqs
import { faqsRoutes } from '@/views/faqs'

// Views - legal
import { legalRoutes } from '@/views/legal'

// Views - htmlBuilder
import { htmlBuilderRoutes } from '@/views/htmlBuilder'

// Views - automation
import { automationRoutes } from '@/views/automation'

// Views - whitelabel
import { whitelabelRoutes } from '@/views/whitelabel'

// Views - twoWay
import { twoWayRoutes } from '@/views/twoWayMessaging'

import handleOrganizationPlanSuspended from './organizationPlanSuspendedHandler'
import handleWhitelabelConfig from './whitelabelConfigHandler'

Vue.use(Router)

// ? Essa lista ficam as rotas que necessitam de organizationId.
const rotasComOrganizationId = [
  {
    path: 'waiting',
    name: 'waitingConfiguration',
    component: WaitingConfiguration,
    meta: { requiresAuth: true },
  },

  {
    path: 'planSetup',
    name: 'OrganizationPendingPlan',
    component: OrganizationPendingPlan,
    meta: { requiresAuth: true },
  },

  {
    path: '/',
    component: TheContainer,
    children: [
      {
        path: 'download/:file',
        name: 'download',
        component: Download,
        meta: { requiresAuth: true },
      },
      {
        path: 'home',
        name: 'home',
        component: Home,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/',
    component: TheContainerFluid,
    children: [
      {
        path: 'settings',
        name: 'settings',
        component: TheMainSidebar,
        meta: { requiresAuth: true },
        children: [
          ...userRoutes,
          ...sendersRoutes,
          ...securityRoutes,
          ...organizationRoutes,
          ...transactionRoutes,
          ...plansSubscriptionsRoutes,
          ...whitelabelRoutes,
          ...twoWayRoutes,
        ],
      },
      {
        path: 'api/documentation',
        name: 'documentation',
        component: DocumentationWrapper,
        meta: { requiresAuth: true },
      },
      {
        path: 'faqs',
        name: 'faqs',
        component: EmptyContainer,
        children: [...faqsRoutes],
        meta: { requiresAuth: true },
      },
      {
        path: 'legal',
        name: 'legal',
        component: EmptyContainer,
        children: [...legalRoutes],
        meta: { requiresAuth: true },
      },
      {
        path: '3ds',
        name: 'paymentConfirmation3ds',
        component: PaymentConfirmation3ds,
        meta: { requiresAuth: true },
      },
    ],
  },
  ...htmlBuilderRoutes,
  ...audienceRoutes,
  ...campaignRoutes,
  ...templateRoutes,
  ...requestRoutes,
  ...balanceRoutes,
  ...backOfficeRoutes,
  ...transactionLogsRoutes,
  ...automationRoutes,
]

// ? Configurações gerais de rotas
const appRoutes = [
  {
    path: '/',
    redirect: '/auth/login',
  },
  {
    path: '/login',
    redirect: '/auth/login',
  },
  {
    path: '/org/:organizationId',
    redirect: '/auth/login',
    meta: { requiresOrganizationId: true, requiresAuth: true },
    component: EmptyContainer,
    children: [...rotasComOrganizationId],
  },
  {
    name: 'setOrganization',
    path: '/setOrganization/:id',
    meta: { requiresAuth: true },
    component: setOrganization,
  },
  ...authRoutes,
  {
    path: '/assets/preview',
    component: () => import('../views/AssetsPreview.vue'),
  },
  {
    path: '*',
    name: 'notFound',
    component: notFound,
  },
  {
    path: '/countDown',
    name: 'countDown',
    component: CountDown,
  },
  {
    path: '/error',
    name: 'error',
    component: notFound,
  },
]

const routes = [...appRoutes]
// const routes = [...appRoutes, ...authRoutes, ...audienceRoutes, ...campaignRoutes, ...templateRoutes, ...requestRoutes]

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes,
})

router.beforeEach(async (to, from, next) => {
  // Insere as configurações padrões no escopo global do vue
  try {
    var response = await axios.create().get('/config/config-env.json', {
      params: {
        v: Math.round(Math.random() * 100),
      },
    })
    Vue.prototype.$configs = response.data
  } catch (error) {
    // TODO qnd hover ambiente de produção deixar setado aqui ao menos o dominio do ambiente.
    // Para o user conseguir fazer as requisições
  }

  const isDefaultHost = window.location.host == Vue.prototype.$configs.VUE_APP_ROOT_HOST
  await handleWhitelabelConfig(isDefaultHost, store.state.whitelabel.isWhitelabelConfigFresh, to, next)

  if (to.meta.feature_flag) {
    if (await checkFeatures(to.meta.feature_flag)) next()
    else next({ name: 'error' })
  }

  // ? Verifica se os dados da sessão estão carregados
  if (to.meta.requiresAuth || to.matched[0].meta.requiresAuth) {
    if (!store.state.auth.session.user) {
      next({ name: 'load', query: { next: to.name, ...to.query }, params: to.params, hash: to.hash })
      return
    }
  }

  // ! Regra de utilização de organizationId
  if (to.matched[0] && to.matched[0].meta.requiresOrganizationId) {
    if (!to.params.organizationId) {
      next({ name: 'Login' })
    }
  }

  if (to.name == 'home') {
    store.dispatch('audience/hasAudience', store.state.auth.organizationId)
  }

  if (to.name == 'LoginWithInvite') {
    if (store.getters['auth/isLoggedIn']) {
      next({ name: 'AcceptInvite', params: { inviteId: to.params.inviteId } })
      return
    }
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // TODO Rever essa definição. No momento que foi alterado, o valor do getter isLoggedIn não estava retornando o valor esperado. Ao que parece não estava atualizando o valor, mesmo com a condição de retorno sendo verdadeira, entretanto estava retornando falso.
    // if (store.getters['auth/isLoggedIn']) {
    if (localStorage.getItem('accessToken')) {
      const fallbackRouteName = 'manage-balance-plans'
      const isOrganizationPlanSuspended = await handleOrganizationPlanSuspended(store.state.auth.organizationId, to, fallbackRouteName)

      if (isOrganizationPlanSuspended && !store.getters['auth/isSendit']) {
        next({ name: fallbackRouteName, query: { suspendedPlan: true }, params: to.params })
      } else {
        next()
      }

      return
    }

    next({ name: 'Login' })
  } else {
    next()
  }
})

export default router
